import React, { useState, useEffect } from "react";
import FormField from "../../../components/ui/FormField";
import { Button } from "../../../components/Button";

const MbpFourForm = () => {

    const [partAEntries, setPartAEntries] = useState(() => {
        const saved = localStorage.getItem("mbp4_partA_data");
        return saved ? JSON.parse(saved) : [{ id: Date.now() }];
    });

    useEffect(() => {
        localStorage.setItem("mbp4_partA_data", JSON.stringify(partAEntries));
    }, [partAEntries]);

    const updatePartA = (id, field, val) => {
        setPartAEntries(prev =>
            prev.map(e => e.id === id ? { ...e, [field]: val } : e)
        );
    };

    const addPartA = () => setPartAEntries([...partAEntries, { id: Date.now() }]);
    const deletePartA = id =>
        partAEntries.length > 1 && setPartAEntries(partAEntries.filter(e => e.id !== id));

    
    const [partBEntries, setPartBEntries] = useState(() => {
        const saved = localStorage.getItem("mbp4_partB_data");
        return saved ? JSON.parse(saved) : [{ id: Date.now() }];
    });

    useEffect(() => {
        localStorage.setItem("mbp4_partB_data", JSON.stringify(partBEntries));
    }, [partBEntries]);

    const updatePartB = (id, field, val) => {
        setPartBEntries(prev =>
            prev.map(e => e.id === id ? { ...e, [field]: val } : e)
        );
    };

    const addPartB = () => setPartBEntries([...partBEntries, { id: Date.now() }]);
    const deletePartB = id =>
        partBEntries.length > 1 && setPartBEntries(partBEntries.filter(e => e.id !== id));


    const [signatureInfo, setSignatureInfo] = useState(() => {
        const saved = localStorage.getItem("mbp4_signature_info");
        return saved ? JSON.parse(saved) : { signature: "", place: "", date: "" };
    });

    const updateSignature = (field, value) => {
        const updated = { ...signatureInfo, [field]: value };
        setSignatureInfo(updated);
        localStorage.setItem("mbp4_signature_info", JSON.stringify(updated));
    };

const saveData = () => {
    const payload = {
        registerName: "MBP-4",
        partA: partAEntries.map(e => ({
            id: e.id || "",
            date: e.date || "",
            party: e.party || "",
            director: e.director || "",
            relation: e.relation || "",
            terms: e.terms || "",
            armsLength: e.armsLength || "",
            boardApproval: e.boardApproval || "",
            present: e.present || "",
            favour: e.favour || "",
            against: e.against || "",
            neutral: e.neutral || "",
            nextMeet: e.nextMeet || "",
            ref188: e.ref188 || "",
            amount: e.amount || "",
            shareholderApproval: e.shareholderApproval || "",
            signature: e.signature || "",
            remarks: e.remarks || ""
        })),
        partB: partBEntries.map(e => ({
            id: e.id || "",
            entity: e.entity || "",
            director: e.director || "",
            nature: e.nature || "",
            shareholding: e.shareholding || "",
            interestDate: e.interestDate || ""
        })),
        signatureInfo: {
            place: signatureInfo.place || "",
            date: signatureInfo.date || "",
            signature: signatureInfo.signature || ""
        }
    };

    console.log("MBP-4 PAYLOAD:");
    console.log(JSON.stringify(payload, null, 2));
};



    return (
        <div>

            <div className="bg-white px-6 py-2 rounded-lg shadow border-b-4 mb-4 text-center">
                <h1 className="text-2xl text-gray-900 uppercase">Form MBP - 4</h1>
                <h2 className="text-lg font-semibold">Register of contracts & bodies etc. in which directors are interested</h2>
                <p className="text-xs italic text-gray-600 mt-1">
                    [Pursuant to section 189(1) and rule 16(1)]
                </p>
            </div>

            <h3 className="text-lg font-bold uppercase text-slate-700 mb-3">
                A. Related Party Transactions / Directors Interested
            </h3>

            <div className="space-y-10">
                {partAEntries.map((entry, i) => (
                    <div key={entry.id} className="bg-white border shadow-md rounded-lg">
                        <div className="bg-primary text-white px-4 py-2 flex justify-between items-center">
                            <span className="text-xs font-semibold">Entry A-{i + 1}</span>
                            {partAEntries.length > 1 && (
                                <button
                                    className="text-[10px] bg-red-600 px-2 py-1 rounded hover:bg-red-700"
                                    onClick={() => deletePartA(entry.id)}
                                >
                                    Remove
                                </button>
                            )}
                        </div>

                        {/* Fields */}
                        <div className="p-6 grid grid-cols-1 md:grid-cols-3 gap-6">

                            <FormField type="date" label="(1) Date of contract" value={entry.date} onChange={v => updatePartA(entry.id,"date",v)} />
                            <FormField label="(2) Party name" value={entry.party} onChange={v => updatePartA(entry.id,"party",v)} />
                            <FormField label="(3) Interested director" value={entry.director} onChange={v => updatePartA(entry.id,"director",v)} />

                            <FormField type="description" label="(4) Relation / Nature of interest" value={entry.relation} onChange={v => updatePartA(entry.id,"relation",v)} />
                            <FormField type="description" label="(5) Principal terms" value={entry.terms} onChange={v => updatePartA(entry.id,"terms",v)} />
                            <FormField label="(6) Arm’s length? (Yes/No)" value={entry.armsLength} onChange={v => updatePartA(entry.id,"armsLength",v)} />

                            <FormField type="date" label="(7) Board approval date" value={entry.boardApproval} onChange={v => updatePartA(entry.id,"boardApproval",v)} />

                            {/* Voting Details 8-10 */}
                            <FormField label="(8) Directors present" value={entry.present} onChange={v => updatePartA(entry.id,"present",v)} />
                            <FormField label="(9) Voted in favour" value={entry.favour} onChange={v => updatePartA(entry.id,"favour",v)} />
                            <FormField label="(10) Voted against" value={entry.against} onChange={v => updatePartA(entry.id,"against",v)} />

                            <FormField label="(11) Neutral" value={entry.neutral} onChange={v => updatePartA(entry.id,"neutral",v)} />

                            <FormField type="date" label="(12) Next meeting signature date" value={entry.nextMeet} onChange={v => updatePartA(entry.id,"nextMeet",v)} />
                            <FormField label="(13) Section 188 item reference (a-g)" value={entry.ref188} onChange={v => updatePartA(entry.id,"ref188",v)} />
                            <FormField label="(14) Contract value" value={entry.amount} onChange={v => updatePartA(entry.id,"amount",v)} />

                            <FormField type="date" label="(15) Shareholders approval date" value={entry.shareholderApproval} onChange={v => updatePartA(entry.id,"shareholderApproval",v)} />
                            <FormField label="(16) Signature" value={entry.signature} onChange={v => updatePartA(entry.id,"signature",v)} />
                            <FormField type="description" label="(17) Remarks" value={entry.remarks} onChange={v => updatePartA(entry.id,"remarks",v)} />

                        </div>
                    </div>
                ))}
            </div>

            <Button label='Add New Part A Entry' onClick={addPartA} className="mt-2" />
             


            <h3 className="text-lg font-bold uppercase text-slate-700 mt-12 mb-3">
                B. Directors’ Interests in Other Bodies Corporate
            </h3>

            <div className="space-y-10">
                {partBEntries.map((entry, i) => (
                    <div key={entry.id} className="bg-white border shadow-md rounded-lg">

                        <div className="bg-primary text-white px-4 py-2 flex justify-between items-center">
                            <span className="text-xs font-semibold">Entry B-{i + 1}</span>
                            {partBEntries.length > 1 && (
                                <button className="bg-red-600 text-[10px] px-2 py-1 rounded"
                                    onClick={() => deletePartB(entry.id)}>
                                    Remove
                                </button>
                            )}
                        </div>

                        <div className="p-6 grid grid-cols-1 md:grid-cols-3 gap-6">
                            <FormField label="Company / Firm / Association" value={entry.entity} onChange={v=>updatePartB(entry.id,"entity",v)} />
                            <FormField label="Interested Director" value={entry.director} onChange={v=>updatePartB(entry.id,"director",v)} />
                            <FormField type="description" label="Nature of interest" value={entry.nature} onChange={v=>updatePartB(entry.id,"nature",v)} />

                            <FormField label="Shareholding (%)" value={entry.shareholding} onChange={v=>updatePartB(entry.id,"shareholding",v)} />
                            <FormField type="date" label="Date Interest Arose/Changed" value={entry.interestDate} onChange={v=>updatePartB(entry.id,"interestDate",v)} />
                        </div>
                    </div>
                ))}
            </div>

            <Button label='Add New Part B Entry' onClick={addPartB} className="mt-2"/>
            

            <div className="bg-white p-6 mt-12 rounded-lg shadow grid grid-cols-1 md:grid-cols-3 gap-6">
                <FormField label="Place" value={signatureInfo.place} onChange={v=>updateSignature("place",v)} />
                <FormField type="date" label="Date" value={signatureInfo.date} onChange={v=>updateSignature("date",v)} />
                <FormField label="Signature (MD/Director/Secretary)" value={signatureInfo.signature} onChange={v=>updateSignature("signature",v)} />
            </div>
<Button
    label="SAVE"
    onClick={saveData}
    className="mt-2"
/>
        </div>
    );
};

export default MbpFourForm;
